// @react
import React, { useRef } from 'react'
// @types
import { CreateAccountFormValues } from 'modules/common/forms/types/createAccount'
// @libraries
import {
  Control,
  Controller,
  UseFormMethods,
  FieldErrors,
} from 'react-hook-form'
// @commons
import { ATD_country_options } from 'modules/common/forms/fields/_config/addresss'
// @components
import Grid from '@bit/atd.web.grid'
import Banner from '@bit/atd.web.banner'
import Select from '@bit/atd.web.select'
import InputRadioGroup from '@bit/atd.web.forms.input-radio-group'
// @module components
import AddressInputs from './Address'
import AddressAutoComplete from 'modules/common/forms/fields/contact/AddressAutoComplete'

type PropsType = {
  control: Control<CreateAccountFormValues>
  formMethods: UseFormMethods<CreateAccountFormValues>
}

type PropsErrorType = {
  errors: FieldErrors
}

const Contact = ({
  formMethods,
  control,
  errors,
}: PropsType & PropsErrorType) => {
  /******************************************
   * REFS
   ******************************************/

  const typeAddressRef = useRef<HTMLInputElement | null>(null)
  const countryRef = useRef<HTMLInputElement | null>(null)

  /******************************************
   * RENDER
   ******************************************/

  return (
    <>
      <Grid container spacing={4}>
        {/* Banner */}
        <Grid xs={12} item>
          <Banner icon="alert">
            Knowing your location enables us to enhance your ATD experience with
            relevant information and local events.
          </Banner>
        </Grid>

        {/* Places Auto Complete */}
        <AddressAutoComplete formMethods={formMethods} name={'AddressOne'} />

        {/* Type of Address */}
        <Grid xs={12} item>
          <Controller
            control={control}
            name="addressType"
            onFocus={() => typeAddressRef?.current?.focus()}
            render={({ onChange, onBlur, value }) => (
              <InputRadioGroup
                name="addressType"
                legend="What type of address is this?"
                layout="column"
                labelPlacement="right"
                size="small"
                value={value as string}
                inputRef={typeAddressRef}
                onBlur={onBlur}
                onChange={onChange}
                required
                options={[
                  {
                    label: 'Personal',
                    value: 'HOME',
                  },
                  {
                    label: 'Business',
                    value: 'BUSINESS',
                  },
                ]}
                error={!!errors?.addressType}
                errorText={errors?.addressType?.message}
              />
            )}
          />
        </Grid>

        {/* Country */}
        <Grid xs={12} sm={6} item>
          <Controller
            control={control}
            name="countryCode"
            onFocus={() => countryRef?.current?.focus()}
            render={({ onChange, onBlur, value }) => (
              <Select
                native
                name="countryCode"
                label="Country"
                placeholder="Choose your country."
                required
                onBlur={onBlur}
                onChange={onChange}
                value={value as string}
                inputRef={countryRef}
                options={ATD_country_options}
                error={!!errors?.countryCode}
                errorText={errors?.countryCode?.message}
              />
            )}
          />
        </Grid>

        {/* Address Switcher */}
        <AddressInputs
          formMethods={formMethods}
          control={control}
          errors={errors}
        />

        {/*<HiddenGridItem formMethods={formMethods} control={control} />*/}
      </Grid>
    </>
  )
}

export default Contact
